import React from "react";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../mock/mock";

const ServiceCard = ({ s }) => {
  return (
    <a
      href="#"
      className="group block"
    >
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-neutral-100">
        <img
          src={s.image}
          alt={s.title}
          className="absolute inset-0 w-full h-full object-cover grayscale group-hover:scale-105 group-hover:grayscale-0 transition-all duration-[900ms] ease-out"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-500" />
        <div className="absolute top-4 right-4 w-10 h-10 rounded-full bg-white text-black inline-flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all duration-300">
          <ArrowUpRight className="w-4 h-4" />
        </div>
      </div>
      <div className="mt-5">
        <h4 className="font-display text-3xl md:text-4xl uppercase leading-none">
          {s.title}
        </h4>
        <p className="mt-3 text-sm text-black/65 leading-relaxed max-w-sm">
          {s.blurb}
        </p>
      </div>
    </a>
  );
};

const Services = () => {
  return (
    <section className="bg-white text-black">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-36">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:items-end mb-16">
          <div className="md:col-span-8">
            <p className="text-[11px] uppercase tracking-[0.32em] text-black/55 mb-6">
              Products & Services
            </p>
            <h3 className="font-display text-[12vw] md:text-[5.4vw] uppercase leading-[0.92]">
              From the art <br />
              <span className="font-serif-display italic font-black">to the science.</span>
            </h3>
          </div>
          <p className="md:col-span-4 max-w-md text-black/65 leading-relaxed">
            Explore our full-stack OOH capabilities — from prime media placements
            to creative, production, install and measurement.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-16">
          {SERVICES.map((s) => (
            <ServiceCard key={s.title} s={s} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
